import React, { Fragment, useState, useEffect } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Redirect } from "react-router-dom";
import { set_loading } from "../../../redux/actions/LayoutAction";
import { connect } from "react-redux";
import { apiJson } from "../../../api/Api";
import { toast } from "react-toastify";
import { set_vendor_store } from "../../../redux/actions/StoreAction";
import ClipLoader from "react-spinners/ClipLoader";
import "./editstore.scss";
import "react-toastify/dist/ReactToastify.css";
import { textarea } from "react-dom-factories";
import { getClass, getRandomInt } from "../../../utils/utils";
import { type } from "../../../components/Dropzone/type";
import { FileUploadPromise } from "../../../utils/aws_s3/aws_s3";
import DropzoneElement from "../../../components/Dropzone/DropzoneElement";

const editStoreSchema = Yup.object().shape({
  description_en: Yup.string().required("Required"),
  contact_email: Yup.string().email("Must be email").required("Required"),
  contact: Yup.string().required("Required"),
  logo_image: Yup.string().url("This must be URL").required("Required"),
  no_of_sku: Yup.number().min(1, "Negative not allowed").required("Required"),
  business_name: Yup.string().required("Required"),
  business_type: Yup.string().required("Required"),
  business_website: Yup.string().url("This must be URL").required("Required"),
  bank_name: Yup.string().required("Required"),
  bank_account_title: Yup.string().required("Required"),
  bank_account_no: Yup.number().required("Required"),
  bank_account_iban: Yup.string().required("Required"),
});

const EditStore = (props) => {
  const [initialVal, setInitialVal] = useState("");
  const [loading, setLoading] = useState(false);
  const [redirectBack, setRedirectBack] = useState(false);
  const [data, setData] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);

  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const showSuccess = () => {
    toast.success(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    setRedirectBack(false);
    setLoading(false);
    setInitialVal({
      description_en: props.store?.description_en || "",
      description_ar: props.store?.description_ar || "",
      sender_email: props.store?.sender_email || "",
      contact_email: props.store?.contact_email || "",
      contact: props.store?.vendor_contact || "",
      logo_image: props.store?.logo_image || "",
      no_of_sku: props.store?.no_of_sku || "",
      business_name: props.store?.business_name || "",
      business_type: props.store?.business_type || "",
      business_website: props.store?.business_website || "",
      businsess_license_file: props.store?.businsess_license_file || "",
      bank_name: props.store?.bank_name || "",
      bank_account_title: props.store?.bank_account_title || "",
      bank_account_no: props.store?.bank_account_no || "",
      bank_account_iban: props.store?.bank_account_iban || "",
    });
    props.store?.bank_account_iban && setDataLoading(true);
  }, [props.store]);

  const Update = (values) => {
    setLoading(true);
    setRedirectBack(false);
    apiJson.createStore
      .updateStore({
        store: {
          description_ar: values.description_ar
            ? values.description_ar
            : values.description_en,
          description_en: values.description_en,
          sender_email: values.sender_email,
          contact_email: values.contact_email,
          contact: values.contact.toString(),
          business_name: values.business_name,
          business_type: values.business_type,
          no_of_sku: values.no_of_sku,
          business_website: values.business_website,
          businsess_license_file: values.businsess_license_file,
          bank_account_title: values.bank_account_title,
          bank_account_no: values.bank_account_no,
          bank_account_iban: values.bank_account_iban,
          bank_name: values.bank_name,
          logo_image: values.logo_image,
        },
      })
      .then((response) => {
        if (response.success) {
          message = "Store updated";
          setLoading(false);
          setRedirectBack(true);
          props.set_vendor_store({ vendorStore: response.data });
          showSuccess();
        } else if (!response.status) {
          setLoading(false);
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        } else {
          setLoading(false);
          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
              ? response.errors
              : "something went wrong";
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
          }
        }
      });
  };

  const handleFilesChange = (e, setFieldValue) => {
    setData(true);
    FileUploadPromise(e[0])
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          setFieldValue("logo_image", response.location);
          setData(false);
        }
      })
      .catch((error) => {
        setData(false);
        message = error
          ? error !== ""
            ? error
            : "something went wrong"
          : "something went wrong";
        showError();
      });
  };

  useEffect(
    () => props.set_loading(initialVal !== "" && dataLoading ? false : true),
    // eslint-disable-next-line
    [initialVal, dataLoading]
  );
  return (
    <Fragment>
      <div className="right-content store-page-desktop">
        {initialVal !== "" && dataLoading && (
          <div className="main-row store-page-content-container">
            <div className="form-container">
              <Formik
                initialValues={initialVal}
                validationSchema={editStoreSchema}
                enableReinitialize
                onSubmit={(values) => Update(values)}
              >
                {({ errors, touched, values, setFieldValue }) => (
                  <Form className="store-form mx-auto">
                    <fieldset>
                      <div className="row mx-0">
                        <div className="col-12 p-0">
                          <div className="heading">Store Details</div>
                        </div>
                        <div className="english-col col-6 ">
                          <div className="row mx-0">
                            <div className="label col-4 gx-0">
                              Description English
                            </div>
                            <div className="col-8 input">
                              <Field
                                as={textarea}
                                className={`w-100 ${getClass(
                                  touched.description_en &&
                                    errors.description_en
                                )}`}
                                name="description_en"
                                type="text"
                                placeholder="Description"
                                multiline="true"
                                rows={4}
                              />
                              {touched.description_en &&
                                errors.description_en && (
                                  <div className="english-error">
                                    {errors.description_en}
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="english-col col-6 ">
                          <div className="row mx-0">
                            <div className="label col-4 ">
                              Description Arabic
                            </div>
                            <div className="col-8 input">
                              <Field
                                as={textarea}
                                className="w-100"
                                name="description_ar"
                                type="text"
                                placeholder="وصف"
                                multiline="true"
                                rows={4}
                                style={{ direction: "rtl" }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mx-0">
                        {" "}
                        <div className="english-col col-6">
                          <div className="row mx-0">
                            <div className="label col-4 gx-0">
                              Contact Email
                            </div>
                            <div className="col-8 input">
                              <Field
                                className={`w-100 ${getClass(
                                  touched.contact_email && errors.contact_email
                                )}`}
                                name="contact_email"
                                type="email"
                                placeholder="store@random.com"
                              />
                              {touched.contact_email &&
                                errors.contact_email && (
                                  <div className="english-error">
                                    {errors.contact_email}
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="english-col col-6 ">
                          <div className="row mx-0">
                            <div className="label col-4 ">Contact</div>
                            <div className="col-8 input">
                              <Field
                                className={`w-100 ${getClass(
                                  touched.contact && errors.contact
                                )}`}
                                name="contact"
                                type="number"
                                value={values.contact}
                                placeholder="Enter contact #"
                              />
                              {touched.contact && errors.contact && (
                                <div className="english-error">
                                  {errors.contact}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mx-0">
                        <div className="english-col col-6 ">
                          <div className="row mx-0">
                            <div className="label col-4 gx-0">No of Sku</div>
                            <div className="col-8 input">
                              <Field
                                className={`w-100 ${getClass(
                                  touched.no_of_sku && errors.no_of_sku
                                )}`}
                                name="no_of_sku"
                                type="number"
                                min="0"
                                step="1"
                                value={Math.ceil(values.no_of_sku)}
                                placeholder="10"
                              />
                              {touched.no_of_sku && errors.no_of_sku && (
                                <div className="english-error">
                                  {errors.no_of_sku}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="english-col col-6 ">
                          <div className="row mx-0">
                            <div className="label col-4">Store Logo</div>
                            <div className="col-8 input">
                              {data ? (
                                <ClipLoader color="#000" loading size={20} />
                              ) : values.logo_image ? (
                                <div
                                  className="image-container mx-auto"
                                  style={{
                                    width: "150px",
                                    height: "75px",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <img
                                    src={values.logo_image}
                                    alt="store_logo"
                                    width="auto"
                                    height="auto"
                                    style={{
                                      maxHeight: "75px",
                                      maxWidth: "145px",
                                      height: "auto",
                                      width: "auto",
                                    }}
                                  />
                                </div>
                              ) : (
                                touched.logo_image &&
                                errors.logo_image && (
                                  <div style={{ color: "red" }}>
                                    {errors.logo_image}
                                  </div>
                                )
                              )}
                              <DropzoneElement
                                multiple={false}
                                updateSelectedServiceFiles={(e) =>
                                  handleFilesChange(e, setFieldValue)
                                }
                                value={
                                  values.logo_image !== ""
                                    ? "logo.png"
                                    : "Upload(png,jpeg,etc.)"
                                }
                                type={type.IMAGE}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row mx-0 ">
                        <div className="col-12 p-0">
                          <div className="heading">Bank Details</div>
                        </div>
                        <div className="english-col col-6 ">
                          <div className="row mx-0">
                            <div className="label col-4 ">Bank Name</div>
                            <div className="col-8 input">
                              <Field
                                className={`w-100 ${getClass(
                                  touched.bank_name && errors.bank_name
                                )}`}
                                name="bank_name"
                                type="text"
                                placeholder="Enter bank name"
                              />
                              {touched.bank_name && errors.bank_name && (
                                <div className="english-error">
                                  {errors.bank_name}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="english-col col-6 ">
                          <div className="row mx-0">
                            <div className="label col-4 col-lg-4 gx-0">
                              Bank Account Title
                            </div>
                            <div className="col-8 col-lg-8 input">
                              <Field
                                className={`w-100 ${getClass(
                                  touched.bank_account_title &&
                                    errors.bank_account_title
                                )}`}
                                name="bank_account_title"
                                type="text"
                                placeholder="Enter account title"
                              />
                              {touched.bank_account_title &&
                                errors.bank_account_title && (
                                  <div className="english-error">
                                    {errors.bank_account_title}
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mx-0 ">
                        <div className="english-col col-6">
                          <div className="row mx-0">
                            <div className="label col-4 ">Bank Account #</div>
                            <div className="col-8 input">
                              <Field
                                className={`w-100 ${getClass(
                                  touched.bank_account_no &&
                                    errors.bank_account_no
                                )}`}
                                name="bank_account_no"
                                type="text"
                                placeholder="Enter account no."
                              />
                              {touched.bank_account_no &&
                                errors.bank_account_no && (
                                  <div className="english-error">
                                    {errors.bank_account_no}
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="english-col col-6">
                          <div className="row mx-0">
                            <div className="label col-4 gx-0">
                              Bank Account IBAN
                            </div>
                            <div className="col-8 input">
                              <Field
                                className={`w-100 ${getClass(
                                  touched.bank_account_iban &&
                                    errors.bank_account_iban
                                )}`}
                                name="bank_account_iban"
                                type="text"
                                placeholder="Enter IBAN"
                              />
                              {touched.bank_account_iban &&
                                errors.bank_account_iban && (
                                  <div className="english-error">
                                    {errors.bank_account_iban}
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row mx-0 ">
                        <div className="col-12 p-0">
                          <div className="heading">Business Details</div>
                        </div>
                        <div className="english-col col-6 ">
                          <div className="row mx-0">
                            <div className="label col-4 gx-0">
                              Business Name
                            </div>
                            <div className="col-8 input">
                              <Field
                                className={`w-100 ${getClass(
                                  touched.business_name && errors.business_name
                                )}`}
                                name="business_name"
                                type="text"
                                placeholder="Enter business name"
                              />
                              {touched.business_name &&
                                errors.business_name && (
                                  <div className="english-error">
                                    {errors.business_name}
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="english-col col-6">
                          <div className="row mx-0">
                            <div className="label col-4 ">Business Type</div>
                            <div className="col-8 input">
                              <Field
                                className={`w-100 ${getClass(
                                  touched.business_type && errors.business_type
                                )}`}
                                name="business_type"
                                type="text"
                                placeholder="Enter business type"
                              />
                              {touched.business_type &&
                                errors.business_type && (
                                  <div className="english-error">
                                    {errors.business_type}
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mx-0">
                        <div className="english-col col-6">
                          <div className="row mx-0">
                            <div className="label col-4 gx-0">
                              Business Website
                            </div>
                            <div className="col-8 input">
                              <Field
                                className={`w-100 ${getClass(
                                  touched.business_website &&
                                    errors.business_website
                                )}`}
                                name="business_website"
                                type="text"
                                placeholder="Enter business website"
                              />
                              {touched.business_website &&
                                errors.business_website && (
                                  <div className="english-error">
                                    {errors.business_website}
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </fieldset>

                    {values.businsess_license_file && (
                      <div className="row mb-0">
                        <div className="col-8 mx-auto liscense-file-tag">
                          <div
                            href={values.businsess_license_file}
                            target="_blank"
                          >
                            <span type="span">view Liscense File</span>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="row button-row mx-0">
                      <div className="button-col col-8 mx-auto d-flex flex-column">
                        <div className="button-group d-flex align-items-center">
                          <button
                            className="blue-button"
                            type="submit"
                            disabled={loading}
                            key={getRandomInt(1, 1000)}
                          >
                            {loading ? (
                              <div className="d-flex justify-content-center align-items-center w-100">
                                <ClipLoader color="#fff" loading size={20} />
                              </div>
                            ) : (
                              "Save"
                            )}
                          </button>
                          <button
                            className="gray-button"
                            type="button"
                            onClick={() => setRedirectBack(true)}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    {redirectBack && <Redirect push to="/vendor/profile" />}
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

const mapStateToProsps = (state) => {
  return { store: state.vendorStore.vendorStore, load: state.layout.isLoading };
};

const mapDispatchToProps = { set_vendor_store, set_loading };

export default connect(mapStateToProsps, mapDispatchToProps)(EditStore);
